import { render } from "./PlatformNavbar.vue?vue&type=template&id=67eb4b11&scoped=true"
import script from "./PlatformNavbar.vue?vue&type=script&lang=js"
export * from "./PlatformNavbar.vue?vue&type=script&lang=js"

import "./PlatformNavbar.vue?vue&type=style&index=0&id=67eb4b11&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67eb4b11"]])

export default __exports__